import "./index.less"
import dayjs from "dayjs"
import "dayjs/locale/en"
import "dayjs/locale/vi"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import React, { Component } from "react"
import abpUserConfigurationService from "@services/abpUserConfigurationService"
import Utils from "@utils/utils"
import Exception from "@scenes/common/Exception"
import { AppConfiguration } from "@lib/appconst"

// Initialize dayjs plugins once
dayjs.extend(utc)
dayjs.extend(timezone)

const LoadingSplashScreen = () => {
  return (
    <div id="splash-screen" className="app-splash-screen">
      <div id="splash-default">
        <div className="splash-default-content">
          <div className="splash-logo-container">
            <img
              src="/assets/images/large-logo.png"
              alt="SonKim Land"
              className="splash-logo"
            />
            <div className="splash-ring" />
          </div>
          <div className="splash-slogan">DIFFERENT FROM THE GROUND UP.</div>
        </div>
      </div>
    </div>
  )
}

function withSplashScreen(WrappedComponent) {
  return class extends Component {
    state = {
      loading: true,
      error: null,
    }

    componentDidMount = async () => {
      try {
        const data = await abpUserConfigurationService.getAll()

        if (data) {
          Utils.extend(true, abp, data.data.result)
          abp.clock.provider = Utils.getCurrentClockProvider(
            data.data.result.clock.provider
          )

          dayjs.locale(abp.localization.currentLanguage.name)

          if (abp.clock.provider.supportsMultipleTimezone) {
            dayjs.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId)
          }
        }

        setTimeout(() => {
          this.setState({ loading: false })
        }, AppConfiguration.appLayoutConfig?.loader?.delayTime || 0)
      } catch (error) {
        this.setState({ loading: false, error })
      }
    }

    render() {
      if (this.state.loading) {
        return <LoadingSplashScreen />
      }

      if (this.state.error) {
        return <Exception />
      }

      return <WrappedComponent {...this.props} />
    }
  }
}

export default withSplashScreen
